import { Component, OnInit } from '@angular/core';
import { AbstractWidgetComponent } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';

@Component({
  selector: 'app-visitor-leave-summary',
  templateUrl: './visitor-leave-summary.component.html',
  styleUrls: ['./visitor-leave-summary.component.scss']
})
export class VisitorLeaveSummaryComponent extends AbstractWidgetComponent implements OnInit {


  constructor(
  ) {
    super();
  }

  ngOnInit(): void {
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

}
